import { ChecklistCsv, ChecklistRowCsv } from '../../types/checklist-csv';

const NAME_MAX_CHAR = 250;
const DESCRIPTION_MAX_CHAR = 2000;

/**
 * Check if checklist csv file is valid
 *
 * @param rows Data parsed from csv file
 * @returns [{errorMessage}, ChecklistRow[]]
 */
export function validateData(rows: ChecklistCsv[]): [{ [rowNumber: string]: string[] }, ChecklistRowCsv[]] {
    const errorMessages: { [rowNumber: string]: string[] } = {};
    const checklistRows: ChecklistRowCsv[] = [];

    const checklistNames: { [key: string]: string } = {};

    for (const row of rows) {
        const rowNumber = `${rows.indexOf(row) + 2}`;
        const messages: string[] = [];

        // Skip empty rows
        if (Object.values(row).every((v) => !v)) {
            continue;
        }

        if (!row['Name *']?.trim()) {
            messages.push(`'Name' field cannot be empty.`);
        }

        if (row['Name *']?.trim().length > NAME_MAX_CHAR) {
            messages.push(`'Name' must be within ${NAME_MAX_CHAR} characters.`);
        }

        if (checklistNames['Report Code *'] === row['Name *']?.toLocaleLowerCase()?.trim()) {
            messages.push(`Values in 'Name' field must be unique.`);
        } else {
            checklistNames['Report Code *'] = row['Name *']?.toLocaleLowerCase()?.trim();
        }

        if (!row['Report Code *']?.trim()) {
            messages.push(`'Report Code' field cannot be empty.`);
        }

        if (row.Description && row.Description.trim().length > DESCRIPTION_MAX_CHAR) {
            messages.push(`'Description' must be within ${DESCRIPTION_MAX_CHAR} characters.`);
        }

        if (messages.length !== 0) {
            errorMessages[rowNumber] = messages;
        } else {
            const checklistRow = {
                name: row['Name *'].trim(),
                description: row.Description.trim() === '' ? undefined : row.Description.trim(),
                category: row.Category.trim() === '' ? undefined : row.Category.trim(),
                reportCodes: row['Report Code *'].trim().toLocaleUpperCase().split(','),
            };
            checklistRows.push(checklistRow);
        }
    }

    return [errorMessages, checklistRows];
}
